import { useSyncExternalStore } from 'react';
import { createProgressStore, type KeyValueStorage, type ProgressMap } from './progressModel';

/** `window.localStorage`, or null where reading it throws (blocked site data, some private windows). */
function browserStorage(): KeyValueStorage | null {
  try {
    return typeof window === 'undefined' ? null : window.localStorage;
  } catch {
    return null;
  }
}

/** One store for the page, so the lesson cards and the player stay in step without a context. */
export const progressStore = createProgressStore(browserStorage);

const EMPTY: ProgressMap = {};

/** The progress map; it re-renders when the player records a step. */
export function useLessonProgress(): ProgressMap {
  return useSyncExternalStore(progressStore.subscribe, progressStore.read, () => EMPTY);
}
